module.exports = __webpack_public_path__ + "img/secondday1-1.038e0cf9.jpg";